import {
  FETCH_TESTIMONIALS,
  FETCH_TESTIMONIALS_SUCCESS,
  FETCH_TESTIMONIALS_FAIL,
} from './constants';

export const loadTestimonials = () => ({
  type: FETCH_TESTIMONIALS,
});

export const loadTestimonialsSuccess = (payload) => ({
  type: FETCH_TESTIMONIALS_SUCCESS,
  payload,
});

export const loadTestimonialsFail = (payload) => ({
  type: FETCH_TESTIMONIALS_FAIL,
  payload,
});
